/**
 * Mirrors backend `userCanAccessStudentLetterGeneration` for UI (student letters tab).
 * Super admin always has access.
 */
export function canAccessStudentLetterGeneration(user, row) {
  if (!user || !row) return false;
  const role = String(user.role || '').toLowerCase();
  if (role === 'super_admin') return true;
  const mode = String(row.access_mode || 'all').toLowerCase();
  if (mode === 'all') return true;
  if (mode === 'superadmin_only') return false;
  if (mode === 'admin_superadmin') return role === 'admin' || role === 'manager';
  if (mode === 'specific_users') {
    let ids = row.specific_user_ids;
    if (typeof ids === 'string') {
      try {
        ids = JSON.parse(ids);
      } catch {
        ids = [];
      }
    }
    if (!Array.isArray(ids)) ids = [];
    return ids.map(Number).includes(Number(user.user_id));
  }
  return true;
}
